import { WSTableCell, WSTableColumn } from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import take from "lodash/take";

import { PaystubSummary } from "../../types";

const VISIBLE_WORK_LOGS = 3;

const selectWorkLogsSecondaryText = (
  workLogNumbers: string[]
): string | undefined => {
  const remaining = workLogNumbers.length - VISIBLE_WORK_LOGS;
  return remaining > 0 ? `+ ${remaining} more` : undefined;
};

export const getColumns = (): WSTableColumn<PaystubSummary>[] => [
  {
    config: { header: { text: "Employee" }, gridTemplateSizeMax: "2fr" },
    renderFunction: rowItem => (
      <WSTableCell
        secondaryText={rowItem.data.employeeId}
        text={rowItem.data.employeeName}
      />
    )
  },
  {
    config: { header: { text: "Work log #" }, gridTemplateSizeMax: "2fr" },
    renderFunction: rowItem => (
      <WSTableCell
        secondaryText={selectWorkLogsSecondaryText(rowItem.data.workLogNumbers)}
        text={take(rowItem.data.workLogNumbers, VISIBLE_WORK_LOGS).join(", ")}
      />
    )
  },
  {
    config: { header: { text: "Net amount" }, gridTemplateSizeMax: "1fr" },
    renderFunction: rowItem => (
      <WSTableCell text={formatMoney(rowItem.data.netAmount, Currency.USD)} />
    )
  },
  {
    config: { header: { text: "Gross amount" }, gridTemplateSizeMax: "1fr" },
    renderFunction: rowItem => (
      <WSTableCell text={formatMoney(rowItem.data.grossAmount, Currency.USD)} />
    )
  }
];
